import React from 'react'
import styled from '@emotion/styled'

import RadioToggle from '../generic/toggles/radioToggle'
import { ButtonGroupWrap } from '../generic/buttonGroup'
import { grayDark40, grayLight20, highlightBlueBase } from '../../constants/principles'
import { fontSizeXSmall, fontSize2XSmall } from '../../constants/principles'
import DoneModal from '../generic/modals/DoneModal'
import { ModalContentNormal } from '../generic/Basics.js'

export default ({ options = [], setShowModal, updateGlobalState, changeVehicleOptionIsSelected, singleOption = [], isDisabled }) => {
  const categoryOptions = {}
  const standardEquipment = singleOption
  const filterStandard = option => option.isDefault && !option.hasOptionRelationships
  options &&
    options.forEach(option => {
      if (!filterStandard(option)) categoryOptions[option.categoryName] ? categoryOptions[option.categoryName].push(option) : (categoryOptions[option.categoryName] = [option])
      else standardEquipment.push(option)
    })
  const categoryKeys = Object.keys(categoryOptions)

  const setShowStandardEquipment = () => {
    setShowModal('standardEquipment')
    updateGlobalState({ fireAnalytics: 'cta::standard_equipment' })
  }

  return (
    <>
      <DoneModal name={'standardEquipment'} title={'Standard Equipment'} subtitle={'The pre-selected features are probably on your car. Please review and make any changes.'} onClick={e => setShowModal(false)} informational={false}>
        <ModalContentNormal>
          <StyledButtonGroup>
            {standardEquipment.map(option => (
              <RadioToggle
                key={option.optionId}
                pills={[option.displayName]}
                testId={'vd-bt-standardequipment'}
                isDisabled={option.isDisabled || isDisabled}
                id={option.optionId}
                onClickItem={(index, userIsSelected) => changeVehicleOptionIsSelected(option, userIsSelected)}
                selectedIndex={option.isSelected ? 0 : undefined}
                locked={option.locked}
              />
            ))}
          </StyledButtonGroup>
        </ModalContentNormal>
      </DoneModal>
      <StyledSpan onClick={setShowStandardEquipment}>See standard equipment</StyledSpan>
      {categoryKeys &&
        categoryKeys.map(category => (
          <CategoryDiv key={category}>
            <InnerCategoryDiv>
              <TextDiv>{category}</TextDiv>
              <StyledButtonGroup>
                {categoryOptions[category].map(option => {
                  return (
                    <RadioToggle
                      key={option.optionId}
                      pills={[option.displayName]}
                      testId={'vd-bt-standardequipment'}
                      isSystemChange={option.hasOptionRelationships && option.isSystemChange}
                      id={option.optionId}
                      isDisabled={isDisabled}
                      selectedIndex={option.isSelected ? 0 : undefined}
                      onClickItem={(index, userIsSelected) => {
                        changeVehicleOptionIsSelected(option, userIsSelected)
                      }}
                      onClickSystemChange={e => setShowModal('OptionsModal')}
                    />
                  )
                })}
              </StyledButtonGroup>
            </InnerCategoryDiv>
          </CategoryDiv>
        ))}
    </>
  )
}

const TextDiv = styled.div`
  font-size: ${p => (p.fontSize ? p.fontSize : fontSize2XSmall)};
  font-weight: ${p => p.fontWeight};
  color: ${p => p.fontColor};
  padding-bottom: ${p => (p.padding ? p.padding : 16)}px;
`

const CategoryDiv = styled.div`
  padding-top: 32px;
  font-size: ${fontSizeXSmall};
  color: ${grayDark40};
  text-align: center;
  width: 100%;
  padding-bottom: 32px;
  border-bottom: 1px solid ${grayLight20};
  &:last-child {
    border-style: none;
  }
`
const InnerCategoryDiv = styled.div`
  width: 80%;
  margin: auto;
`
//the margin here lets this div tuck under its header feel free to improve this
const StyledSpan = styled.span`
  margin-top: -8px;
  color: ${highlightBlueBase};
  font-size: ${fontSize2XSmall};
  cursor: pointer;
  :hover {
    text-decoration: underline;
  }
`
const StyledButtonGroup = styled(ButtonGroupWrap)`
  padding-top: 8px;
`
